import React, {Component} from 'react';
import {Button, Icon, Popup,Message,Image} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import {submitReport} from '../../data/report_api';
import {REPORT_ACTIONS_API_URL} from "../../constants/api_routes";
import Loader from "../universal/loader";
import {isSessionExpiringSoon} from "../../utils/validate_session_expiry";
import logo from '../../assets/logosquare.png';

class FloatingSideBarWidget extends Component {
    constructor(props){
        super(props);
        this.state ={
            roomError:undefined,
            showIcons:true
        }
    }

        cloneWithoutImages = (data) => {
    if (Array.isArray(data)) {
        return data.map(item => this.cloneWithoutImages(item));
    } else if (data && typeof data === 'object') {
        const clone = {};
        for (const key in data) {
        if (key === 'image') continue; // skip only the heavy field
        clone[key] = this.cloneWithoutImages(data[key]);
        }
        return clone;
    }
    return data;
    };
    handleReportSubmit = () => {
        try{
        if(isSessionExpiringSoon()){
            this.props.showPasswordWindow(true);
            return;
        }

        this.setState({uploading:true});
        let reportType = this.props.reportDetails['inspection_type'];
        const reportTypes = {"ci": "ci", "co": "co", "inv/ci": "ci", "inv": "ci","sng":"ci"};
        let reportUpdateRooms = this.cloneWithoutImages(this.props.reportUpdates.rooms);
        for (let i = 0; i < reportUpdateRooms.length; i++) {
            reportUpdateRooms[i].groups = [];
            let roomImages = reportUpdateRooms[i].images;
            for (let j = 0; j < roomImages.length; j++) {
                roomImages[j].image = undefined
            }
            reportUpdateRooms[i].images = roomImages;
        }
        let reportUpdateGroups = this.cloneWithoutImages(this.props.reportUpdates.groups);
        for (let i = 0; i < reportUpdateGroups.length; i++) {
            reportUpdateGroups[i].items = [];
        }
        let reportUpdateItems = this.cloneWithoutImages(this.props.reportUpdates.items);
        for (let i = 0; i < reportUpdateItems.length; i++) {
            let itemImages = reportUpdateItems[i].images;
            for (let j = 0; j < itemImages.length; j++) {
                itemImages[j].image = undefined
            }
            reportUpdateItems[i].images = itemImages;
        }

        const reportUpdateApiData = {
            report_id: this.props.reportUpdates['report_id'],
            rooms: reportUpdateRooms,
            groups: reportUpdateGroups,
            items: reportUpdateItems
        };

        submitReport(this.props.other_template? "both" :reportTypes[reportType], reportUpdateApiData).then((response) => {
            if (response.success) {
                this.props.initUploadImages(true);
                this.setState({roomSaved: true,uploading:false,roomError:undefined});
                this.props.resetReportUpdateObject();
                if(this.props.mediaAttachments.length < 1){
                    this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportId);
                }
                setTimeout(() => {
                    this.setState({roomSaved: false})
                }, 5000);
            }
            else {
                let errorMsg =   `Copy / Paste and send to accounts@hinchpm.com the text of the following error  ${response.statusMessage} ${JSON.stringify(this.cloneWithoutImages(reportUpdateApiData))})}`
                this.setState({roomSaved: false,uploading:false,roomError:errorMsg});
                     if (response.statusMessage) {
                        const msg = response.statusMessage.toLowerCase();
                        if (msg.includes("no data") || msg.includes("401") || msg.includes("unauthorized")) {
                            console.log("checked success");
                            this.props.showPasswordWindow(true);
                        }
                    }
                setTimeout(() => {
                    this.setState({roomSaved: false, error: false})
                }, 5000);
            window.alert("Error saving, check error message")
            }
        });
     } catch (err) {
    // Catches unexpected JS/runtime errors
    let errorMsg = `Copy / Paste and send to accounts@hinchpm.com the text of the following error ${err.message} ${(err.stack || '')} ${JSON.stringify(this.cloneWithoutImages(this.props.reportUpdates))} `;
    this.props.logErrorResponse(errorMsg)
    this.setState({ roomSaved: false, uploading: false, roomError: errorMsg });
     window.alert("Error saving, check error message")
  }};

    render() {
        return (
            <div style={{height:this.state.showIcons?"70px":"500px"}}className={`sticky-container ${!this.state.showIcons?"glow-shadow":""}`}>
                {this.state.uploading && <Loader save={true}/>}
                <ul className="sticky">
                <Image className="sidebar-logo"onClick={()=>this.setState({showIcons: !this.state.showIcons})} src={logo}></Image>
         <React.Fragment>
                    <li>
                        <div><Icon name="key" size="big" color='green' onClick={() => {
                            this.props.openSelection("keys");
                        }}/>
                         <p style={{color: "green"}} className="center-aligned">Keys</p></div>
                    </li>
                    <li>
                        <div>
                        <Icon name="clock" size="big" color='green' onClick={() => {
                            this.props.openSelection("meters")
                        }}/> <p style={{color: "green"}} className="center-aligned">Meters</p>
                        </div>
                    </li>
                    <li><div>
                        <Icon name="alarm" size="big" color='green' onClick={() => {
                            this.props.openSelection("alarms")
                        }}/>
                        <p style={{color: "green"}} className="center-aligned">Alarms</p>
                        </div>
                    </li>
                    <li>
                        <div>
                        <Icon name="file" size="big" color='green' onClick={() => {
                            this.props.openSelection("receipts")
                        }}/> 
                        <p style={{color: "green"}} className="center-aligned">Receipts</p>
                        </div>
                    </li>
                    <li><div>
                        <Icon name="shield" size="big" color='green' onClick={() => {
                            this.props.openSelection("disclaimer")
                        }}/>
                        <p style={{color: "green"}} className="center-aligned">Disclaimer</p>
                        </div>
                    </li>
                    {this.props.reportDetails['inspection_type'] == "co" && <li>
                        <div>
                        <Icon name="flag" size="big" color='green' onClick={() => {
                            this.props.openSelection("summary_notes")
                        }}/>
                        <p style={{color: "green"}} className="center-aligned">Summary</p>
                        </div>
                    </li>}
                    <li>
                       <Popup
                            wide={false} // disable the “very wide” preset
                            trigger={
                                <div style={{ zIndex: 85 }}>
                                <Icon name="save" size="big" color={this.state.roomSaved ? 'blue' : 'green'} />
                                <p style={{ color: 'green' }} className="center-aligned">Save</p>
                                </div>
                            }
                            content={
                                <div
                                style={{
                                    maxHeight: '300px',  maxWidth: '350px',  overflowY: 'auto',  overflowX: 'hidden', whiteSpace: 'normal',  wordBreak: 'break-word',  paddingRight: '5px',
                                }}
                                >
                                {this.state.roomError && (
                                    <Message error style={{ wordBreak: 'break-word' }}>
                                    {`Error Saving Rooms - ${this.state.roomError}`}
                                    </Message>
                                )}
                                <Button    style={{ margin: '10px 0' }} positive  disabled={
                                    this.props.reportDetails['ci_image_count'] === 0 &&
                                    this.props.reportDetails['report_type'] !== 'other'
                                    }
                                    content={
                                    this.props.reportDetails['ci_image_count'] === 0 &&
                                    this.props.reportDetails['report_type'] !== 'other'
                                        ? 'No CI Images detected, load a report with check in images present to be able to save'
                                        : 'Save rooms Section?'
                                    }
                                    onClick={() => this.handleReportSubmit()}
                                />
                                </div>
                            }
                            on="click"
                            position="left center"
                            hideOnScroll
                            style={{ zIndex: 500 }}
                        />
                    </li>
                </React.Fragment></ul>   
                </div>
                );
            }

}

export default ReportContainer(FloatingSideBarWidget);


// WEBPACK FOOTER //
// ./src/views/report/floating_sidebar_widget.js